import React from 'react';
import StaticPage, { Section, CardGrid } from './StaticPage';

export default function CityGuides() {
  return (
    <StaticPage title="City Guides for Students" subtitle="Discover what it's like to live and study in Australia's top university cities.">
      <Section title="Choose Your City">
        <CardGrid items={[
          { title: 'Melbourne, VIC', desc: 'Australia\'s cultural capital. Home to UniMelb, Monash, RMIT, and Deakin. World-class cafes, live music, and excellent public transport.' },
          { title: 'Sydney, NSW', desc: 'Iconic harbour city with USYD, UNSW, and UTS. Higher cost of living offset by stunning beaches and a vibrant social scene.' },
          { title: 'Brisbane, QLD', desc: 'Sunny, affordable, and rapidly growing. University of Queensland and QUT campuses are well-served by public transport.' },
          { title: 'Perth, WA', desc: 'Australia\'s most isolated capital but one of the most liveable. UWA and Curtin attract thousands of international students.' },
          { title: 'Adelaide, SA', desc: 'Compact, affordable, and student-friendly. University of Adelaide and UniSA campuses are close to the CBD.' },
          { title: 'Canberra, ACT', desc: 'Home to the Australian National University, ranked in the top 30 globally. Safe, clean, and surprisingly vibrant.' },
        ]} />
      </Section>

      <Section title="Cost of Living Comparison (Weekly)">
        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="bg-[#094f6f] text-white">
                <th className="p-3 text-left rounded-tl-lg">City</th>
                <th className="p-3 text-left">Rent (shared)</th>
                <th className="p-3 text-left">Groceries</th>
                <th className="p-3 text-left">Transport</th>
                <th className="p-3 text-left rounded-tr-lg">Total Est.</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Melbourne', 'A$270–400', 'A$80–120', 'A$45', 'A$395–565'],
                ['Sydney', 'A$300–450', 'A$85–130', 'A$50', 'A$435–630'],
                ['Brisbane', 'A$240–360', 'A$75–110', 'A$40', 'A$355–510'],
                ['Perth', 'A$220–340', 'A$70–110', 'A$40', 'A$330–490'],
                ['Adelaide', 'A$200–320', 'A$70–105', 'A$35', 'A$305–460'],
                ['Canberra', 'A$240–360', 'A$80–115', 'A$40', 'A$360–515'],
              ].map(([city, ...cols], i) => (
                <tr key={i} className={i % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                  <td className="p-3 font-medium text-gray-800">{city}</td>
                  {cols.map((c, j) => <td key={j} className="p-3 text-gray-600">{c}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>

      <Section title="Transport Tips">
        <ul className="list-disc list-inside space-y-2">
          <li><strong>Melbourne:</strong> Get a Myki card for trams, trains, and buses. Student concession available.</li>
          <li><strong>Sydney:</strong> Use an Opal card. Ferries are a scenic way to commute from many suburbs.</li>
          <li><strong>Brisbane:</strong> GoCard works on all TransLink services. Cycling is popular on the Bicentennial Bikeway.</li>
          <li><strong>Perth:</strong> SmartRider card covers Transperth trains and buses. Free transit zone in the CBD.</li>
        </ul>
      </Section>
    </StaticPage>
  );
}
